import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';

// Styles
import './styles/main.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <App />

);

